import { render, staticRenderFns } from "./AsideUserCenter.vue?vue&type=template&id=35e1c9c2&scoped=true&"
import script from "./AsideUserCenter.vue?vue&type=script&lang=js&"
export * from "./AsideUserCenter.vue?vue&type=script&lang=js&"
import style0 from "./AsideUserCenter.vue?vue&type=style&index=0&id=35e1c9c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e1c9c2",
  null
  
)

component.options.__file = "AsideUserCenter.vue"
export default component.exports